import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiClock,FiGift}=FiIcons;

const DiscountTimer=()=> {
  const [timeLeft,setTimeLeft]=useState(24 * 60 * 60); // 24 hours in seconds

  useEffect(()=> {
    const timer=setInterval(()=> {
      setTimeLeft((prev)=> {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    },1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime=(seconds)=> {
    const hours=Math.floor(seconds / 3600);
    const minutes=Math.floor((seconds % 3600) / 60);
    const secs=seconds % 60;
    
    return `${hours.toString().padStart(2,'0')}:${minutes.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
  };

  const progress=((24 * 60 * 60 - timeLeft) / (24 * 60 * 60)) * 100;

  return (
    <motion.div
      initial={{scale: 0.9,opacity: 0}}
      animate={{scale: 1,opacity: 1}}
      transition={{duration: 0.6}}
      className="bg-gradient-to-br from-yellow-500/20 via-orange-500/20 to-red-500/20 border-2 border-yellow-500/50 rounded-3xl p-8 relative overflow-hidden"
    >
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-500/10 via-orange-500/10 to-red-500/10 animate-pulse"></div>
      
      <div className="relative z-10">
        <div className="text-center mb-6">
          <div className="flex items-center justify-center mb-4">
            <SafeIcon icon={FiClock} className="text-4xl text-yellow-400 mr-3 animate-pulse" />
            <h3 className="text-3xl md:text-4xl font-bold text-white">
              โบนัสส่วนลด 500 บาท ทันที!!
            </h3>
          </div>
          
          <div className="text-xl md:text-2xl font-semibold text-yellow-300 mb-2">
            จากราคา <span className="line-through text-gray-400">9,995.-</span> 
          </div>
          
          <div className="text-3xl md:text-4xl font-bold text-green-400 mb-6">
            เหลือเพียง 9,495.-
          </div>
          
          <p className="text-lg text-gray-300 mb-6">
            เมื่อลงทะเบียนภายใน 24 ชม. นับถอยหลัง
          </p>
        </div>

        {/* Timer Display */}
        <div className="bg-slate-800/60 border-2 border-red-500/30 rounded-2xl p-6 mb-6">
          <div className="text-center">
            <p className="text-lg text-gray-300 mb-3">เวลาที่เหลือ:</p>
            <div className="text-5xl md:text-6xl font-bold text-red-400 font-mono mb-4">
              {formatTime(timeLeft)}
            </div>
            <p className="text-sm text-gray-400">
              (นับวินาทีเริ่มต้นจากการเข้าเยี่ยมชม)
            </p>
          </div>
          
          {/* Progress Bar */}
          <div className="mt-6">
            <div className="w-full bg-slate-700 rounded-full h-3">
              <motion.div
                initial={{width: '0%'}}
                animate={{width: `${progress}%`}}
                transition={{duration: 1,ease: 'linear'}}
                className="bg-gradient-to-r from-yellow-500 to-red-500 h-3 rounded-full"
              ></motion.div>
            </div>
            <p className="text-center text-sm text-gray-400 mt-2">
              {Math.round(progress)}% ของเวลาที่ผ่านไป
            </p>
          </div>
        </div>

        <div className="text-center">
          <button className="group relative px-12 py-6 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white font-bold text-xl rounded-full shadow-2xl hover:shadow-yellow-500/30 transition-all duration-300 transform hover:scale-105 border-2 border-yellow-400/50">
            <span className="flex items-center space-x-3">
              <SafeIcon icon={FiGift} className="text-2xl" />
              <span>🔥 จองทันทีรับส่วนลด 500 บาท!</span>
            </span>
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-600 via-orange-600 to-red-600 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            
            {/* Animated Ring */}
            <div className="absolute inset-0 rounded-full border-2 border-white/30 animate-ping"></div>
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default DiscountTimer;